import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class Search extends Vue {
  @Prop({ default: () => {} })
    value: NewDisplayShopSearch;

  render(h) {
    return (
      <div class="search" style={`padding-right: ${this.value.desc.margin / 2}px`}>
        <div class="back-img">
          <el-input placeholder="搜索商品" class="disabled-input" disabled>
            <i class="el-icon-search el-input__icon search-icon-color" slot="suffix" />
          </el-input>
        </div>
      </div>
    );
  }
}
